import { SITE_NAME } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Cta() {
  return (
    <section className="fm-cta" id="contact">
      <div className="fm-container">
        <div className="fm-cta__panel">
          <h2>Ready to equip your team?</h2>
          <p>
            Chat with {SITE_NAME} for a quick recommendation, licence options,
            or studio pricing — we reply live.
          </p>
          <div className="fm-cta__actions">
            <button
              type="button"
              className="fm-btn fm-btn--primary"
              onClick={openZohoChat}
            >
              Start live chat
            </button>
            <a className="fm-btn fm-btn--outline" href="#products">
              Browse software
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
